// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__Au-V5","loginAndroidBadge":"styles_loginAndroidBadge__2D0uV","loginFlexbox":"styles_loginFlexbox__2gP1p","loginWholePage":"styles_loginWholePage__lNSmS"};